module.exports = __webpack_public_path__ + "img/barcelona_les_corts.4669ed23.jpg";